import * as _React from 'react';
import { observer } from 'mobx-react';
import { Route, Switch } from 'react-router-dom';
import { AIAgentTemplatesList } from './AIAgentTemplatesList';
import { AIAgentTemplateDetail } from './AIAgentTemplateDetail';

function _AIAgentTemplates() {
	return (
		<Switch>
			<Route exact path='/ai-agent-templates' component={AIAgentTemplatesList} />
			<Route exact path='/ai-agent-templates/new' component={AIAgentTemplateDetail} />
			<Route exact path='/ai-agent-templates/:id' component={AIAgentTemplateDetail} />
		</Switch>
	);
}

export const AIAgentTemplates = observer(_AIAgentTemplates);
